import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import classNames from 'classnames';
import { CheckCircleFilledMid } from '@zooplus/icons';
import style from '../../DropdownMenu/DropdownMenu.module.scss.js';

/**
 * [source code](https://src.private.zooplus.net/projects/FE/repos/ui-components/browse/src/components/DropdownMenu/DropdownMenuOptionList.tsx)
 *
 * @param {ReactNode} customComponent - (optional) A custom React element that can be used instead of `label` to render the item.
 * @param {DropdownMenuItemImageProps} image - (optional) Image object with shape of {@link DropdownMenuItemImageProps}.
 * @param {boolean} isSelected - (optional) Whether or not the item is the current selection.
 * @param {string} label - Text label for the item.
 * @param {object} options - Custom options object. Values can either be string or object of strings.
 * @param {boolean} roundedImages - (optional) Whether or not images should be automatically rounded with CSS. Works best with square images. Defaults to false.
 */
const DropdownMenuItemContent = (props) => {
    const { image, isSelected, label, options, roundedImages, customComponent = undefined, } = props;
    if (customComponent) {
        return jsx(Fragment, { children: customComponent });
    }
    return (jsxs(Fragment, { children: [(image || options?.countryCode) && (jsx("span", { className: classNames(style['z-dropdown-menu-list__image'], {
                    [style['z-dropdown-menu-list__image--rounded']]: roundedImages,
                }), children: jsx("img", { src: options?.countryCode
                        ? `https://cdn.public.zooplus.net/media/ui-components/v6-latest/png/country-flags/1x1/${options?.countryCode.toLowerCase()}.png`
                        : image?.url, alt: image?.alt || '', width: image?.width || '24', height: image?.height || '24', loading: "lazy" }) })), jsx("div", { className: style['z-dropdown-menu-list__text-label'], children: label }), jsx("span", { className: style['z-dropdown-menu-list__icon-wrap'], children: isSelected && (jsx(CheckCircleFilledMid, { className: style['z-dropdown-menu-list__icon'] })) })] }));
};

export { DropdownMenuItemContent };
//# sourceMappingURL=DropdownMenuItemContent.js.map
